import { InputSearchPro } from 'components/InputSearch';
import { empresaToString } from 'utils/padronesToString';
import BusquedaAvanzadaPadrones from 'views/Recaudacion/Caja/BusquedaAvanzadaPadrones';
import { padronesEnum } from '../enums';

const fieldsInfo = {};

const tabs = [
  {
    title: null,
    fields: [
      'descripcion',
      'actividad_empresarial_especifica',
      'es_arrendamiento',
      'unidad_recaudadora',
      'empresa',
    ],
  },
];

const configs = {
  descripcion: {
    formItemProps: {
      label: 'Descripción',
    },
  },
  actividad_empresarial_especifica: {
    formItemProps: {
      label: 'Actividad Empresarial Especifica',
    },
  },
  es_arrendamiento: {
    formItemProps: {
      label: '¿Es Arrendamiento?',
    },
  },
  unidad_recaudadora: {
    formItemProps: {
      label: 'Unidad Recaudadora',
    },
  },
  empresa: {
    advanced: true,
    control: InputSearchPro,
    advancedComponent: BusquedaAvanzadaPadrones,
    advancedComponentProps: { tipoDePadron: padronesEnum.EMPRESA, allowAdd: false },
    advancedComponentName: 'BusquedaAvanzadaPadrones',
    label: 'Empresa',
    tooltip: 'Búsqueda por Razón social',
    resultProps: {
      name: 'empresa',
      label: 'Empresa',
      render: (empresa) => empresaToString(empresa),
    },
  },
};

const forbiddenProps = [];

export default {
  configs,
  forbiddenProps,
  fieldsInfo,
  tabs,
};
